import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Api from "../../../Services/Api";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Button from "../../../modules/commons/Button";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import {HttpStatus, Status} from "../../common/Constants";
import {mapToObjectDDL} from "../../common/mapper";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";

class MasterKasTable extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeKas",
            label: "Kode Kas",
        },
        {
            name: "namaCabang",
            label: "Nama Cabang",
        },
        {
            name: "name",
            label: "Nama Kas",
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <ToggleButton
                        value={R.equals(val, Status.ACTIVE)}
                        onToggle={(value) => this.props.onToggleChange(value, rowIndex)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "kodeKas",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleModifyingVisibility(val)}>
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.props.onDelete(val)}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            print: false,
        };
    }

    handleModifyingVisibility = async (kodeKas) => {
        if (!R.isNil(kodeKas)) {
            const response = await this.props.callApi(
                Api.create("NAGAMAS_MASTER_DATA").getMasterKasById,
                kodeKas,
            );

            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                const data = response.data.data;
                this.props.onSetState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        kodeKas: data.kodeKas,
                        kodeCabang: mapToObjectDDL(data.cabang.namaDealer, data.cabang.kodeCabang),
                        name: data.name,
                        status: data.status,
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleChangePage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            page: tableState.page + 1,
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            page: 1,
            totalData: 1,
            limit: tableState.rowsPerPage,
        }));
    };

    handlePrint = () => {
        this.setState((prevValue) => ({...prevValue, print: !prevValue.print}));
    };

    render() {
        return (
            <>
                <SimpleDataTable
                    data={this.props.state.dataTable}
                    columns={this.tableColumns}
                    toCount={this.props.state.totalData}
                    rowsPerPage={this.props.state.limit}
                    page={this.props.state.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <>
                            <SimpleButton onClick={() => this.handleModifyingVisibility()}>
                <span>
                  <i className="fa fa-plus margin-right-10px"></i>
                </span>
                                Tambah
                            </SimpleButton>
                            <SimpleButton secondary onClick={this.handlePrint}>
                                Cetak
                            </SimpleButton>
                        </>
                    }
                />
                {this.state.print && <SimplePrintTable onClearPrint={this.handlePrint}/>}
            </>
        );
    }
}

export default MasterKasTable;
